import React from "react";

import Select, { StylesConfig } from "react-select";

function DropDownPicker({ options, onChange, value, isDisabled, isComprobanteGroup }) {

  return (
    <Select
      placeholder={isComprobanteGroup ? "Seleccione los grupos de usuario que visualizarán el comprobante" : isDisabled ? "Aún no hay usuarios que pertenezcan a este grupo" :  "Seleccione usuarios pertenecientes al grupo"}
      closeMenuOnSelect={true}
      closeMenuOnScroll={false}
      menuPlacement="auto"
      menuPosition="fixed"
      menuShouldScrollIntoView={false}
      styles={{
        container: (base) => ({
          ...base,
          width: "100%",
        }),
        valueContainer: (base) => ({
          ...base,
          justifyContent: "center",
        }),
        multiValue: (base) => ({
          ...base,
          justifyContent: "center",
        }),
        multiValueLabel: (base) => ({
          ...base,
          backgroundColor: "rgb(116, 122, 218)",
          color: "white",
          borderRadius: "none",
          fontSize: "1rem",
        }),

        multiValueRemove: (base) => ({
          ...base,
          backgroundColor: "rgb(116, 122, 218)",
          color: "white",
          borderRadius: "none",
          fontSize: "1rem",
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: "20vh",
          overflowY: "auto",
        }),
        option: (base, state) => ({
          ...base,
          textAlign: "center",
          backgroundColor: state.isFocused ? "#f8b03d66" : "white",
          color: "black",
        }),
      }}
      isMulti
      options={options}
      onChange={(value) => onChange(value)}
      value={value}
      isDisabled={isDisabled}
    />
  );
}
export default DropDownPicker